import React from "react";
import useThunkReducer from "../../HOC/useThunkReducer";
import { blogReducer, initialState } from "./reducer";

export const BlogContext = React.createContext({});

const BlogContextWrapper = ({ children }) => {
  const [blogState, dispatch] = useThunkReducer(blogReducer, initialState);
  return (
    <BlogContext.Provider
      value={{
        blogState,
        dispatch,
      }}
    >
      {children}
    </BlogContext.Provider>
  );
};

export default BlogContextWrapper;
